<aside class="move-panel" role="complementary" aria-label="Move people" data-testid="move-panel">
  <div class="move-panel__header">
    <h2 class="move-panel__title">Move people</h2>
    <admin-badge
      [label]="selectionCount + ' selected'"
      [role]="'neutral'"
      data-testid="move-panel-count"
    ></admin-badge>
    <button
      mat-icon-button
      type="button"
      class="move-panel__close"
      data-testid="move-panel-close"
      aria-label="Close move panel"
      (click)="onDismissClick()"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <div class="move-panel__destination" data-testid="move-panel-destination" [formGroup]="destinationForm">
    <admin-org-picker
      [control]="destinationForm.controls.destination"
      [selectedName]="destinationOrgName"
      [activeOnly]="true"
      label="Destination organization"
      inputTestId="move-panel-destination-input"
      optionTestId="move-panel-destination-option"
      noMatchesTestId="move-panel-destination-no-matches"
      cappedHintTestId="move-panel-destination-capped-hint"
      errorTestId="move-panel-destination-error-slot"
      (optionSelected)="onDestinationSelected($event)"
      (orgInvalidated)="onDestinationInvalidated()"
    ></admin-org-picker>
    @if (destinationError) {
      <p class="move-panel__destination-error" data-testid="move-panel-destination-error">
        <mat-icon aria-hidden="true" class="move-panel__destination-error-icon">error_outline</mat-icon>
        <span>{{ destinationError }}</span>
      </p>
    }
  </div>

  <div class="move-panel__body">
    @if (results) {
      <div class="move-panel__results" data-testid="move-panel-results">
        @for (result of results; track trackByResultId($index, result)) {
          <div class="move-panel__result-row" data-testid="move-panel-result-row">
            <admin-badge
              [label]="outcomeLabel(result.outcome)"
              [role]="badgeRole(result.outcome)"
              ariaLabel="Outcome: {{ outcomeLabel(result.outcome) }}"
            ></admin-badge>
            <span class="move-panel__result-name">{{ result.first_name }} {{ result.last_name }}</span>
            @if (result.reason) {
              <span class="move-panel__result-reason">{{ result.reason }}</span>
            }
          </div>
        }
      </div>
    } @else if (selectionCount === 0) {
      <admin-state
        variant="empty-no-data"
        heading="Nobody gathered yet"
        message="Tick people in the list to gather them into this move."
        data-testid="move-panel-empty"
      ></admin-state>
    } @else {
      <div class="move-panel__list" data-testid="move-panel-list">
        @for (person of selectedPeople; track trackBySelectedPersonId($index, person)) {
          <div class="move-panel__row" data-testid="move-panel-row">
            <span class="move-panel__row-name">{{ fullName(person) }}</span>
            <button
              mat-icon-button
              type="button"
              data-testid="move-panel-remove"
              [attr.aria-label]="'Remove ' + fullName(person) + ' from this move'"
              (click)="remove(person.org_person_id)"
            >
              <mat-icon aria-hidden="true">close</mat-icon>
            </button>
          </div>
        }
      </div>
    }
  </div>

  <div class="move-panel__footer">
    <button
      mat-button
      type="button"
      data-testid="move-panel-cancel"
      (click)="onCancelClick()"
    >
      Cancel move
    </button>
    @if (!results && selectionCount > 0) {
      <button
        mat-flat-button
        color="primary"
        type="button"
        data-testid="move-panel-confirm"
        (click)="onMoveClick()"
      >
        Move {{ selectionCount }} {{ selectionCount === 1 ? 'person' : 'people' }}
      </button>
    }
  </div>
</aside>
